import _ from "lodash";
import { getHomeroomStudentsCountFromCache } from "Homeroom/modules/HomeroomGraphqlHelpers";
import { getOrganizationDetailsFromCache } from "modules/CommonGraphqlHelpers";

import { getSnPEvaluationCyclesBasicDetailsFromCache } from "SnP_v2/modules/SnPGraphqlHelpers";
import { getSnpV2Cycles } from "SnP_v2/modules/SnPUtils";

export const getHomeroomStudentsCount = ({
  userId,
  academicYearSelected,
  currentCurriculumProgramId,
}) => {
  const variables = {
    id: userId,
    staffStudentsFilters: {
      relation: "HOMEROOM",
      academicYearIds: _.get(academicYearSelected, "id", null),
      curriculumProgramIds: currentCurriculumProgramId,
    },
  };

  const queryData = getHomeroomStudentsCountFromCache(variables);

  return _.get(queryData, "studentsRelation.totalCount", 0);
};

export const getNewSnPCyclesCount = ({
  organizationId,
  curriculumProgramId,
}) => {
  const organizationData = getSnPEvaluationCyclesBasicDetailsFromCache({
    id: organizationId,
    filters: {
      isArchived: false,
      curriculumProgramId,
    },
  });
  const cycles = _.get(organizationData, "snpEvaluationCycles", []);

  const newSnpCycles = getSnpV2Cycles({ cycles });

  return _.size(newSnpCycles);
};

export const getOauthServiceName = ({ organizationId }) => {
  const organizationDetails = getOrganizationDetailsFromCache(organizationId);
  return _.first(_.get(organizationDetails, "oauthServiceName", null));
};
